import { render } from "./SingleOrder.vue?vue&type=template&id=9f1cfba2&scoped=true"
import script from "./SingleOrder.vue?vue&type=script&lang=js"
export * from "./SingleOrder.vue?vue&type=script&lang=js"

import "./SingleOrder.vue?vue&type=style&index=0&id=9f1cfba2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f1cfba2"]])

export default __exports__